import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { IoClose } from "react-icons/io5";
import { Box } from '@mui/material';


export default function ReajectReason(props) {
  
  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        fullWidth
        maxWidth="sm"
        onClose={props.handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (e) => {   
            e.preventDefault();        
            props.handleReject;
          },
        }}
      >
        <Box sx={{cursor:'pointer',fontSize:'25px',position:'absolute',top:8,right:8}} onClick={()=>props.handleClose()}>
          <IoClose />
        </Box>
        
        <DialogContent sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
          
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="reason"
            label="Reason"
            type="text"
            value={props.rejectReason}
            fullWidth
            variant="standard"
            onChange={(e)=>props.setRejectReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={props.isLoading} onClick={props.handleClose}>Cancel</Button>
          <Button disabled={props.isLoading} onClick={props.handleReject}>Submit</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}